// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.column-graph[data-v-0a299566] {\r\n  width: 100%;\r\n  height: 100%;\r\n  text-align: center;\n}\n.dados[data-v-0a299566] {\r\n  display: flex;\r\n  flex-direction: column;\n}\n.dados .dado[data-v-0a299566] {\r\n  margin: 0.2rem 0;\n}\r\n", ""]);
// Exports
module.exports = exports;
